import React from 'react';

function PaymentPage() {
    return (
        <div>Payment Page</div>
    );
}

export default PaymentPage;